import moment from 'moment';
import React from 'react'

export const TableRow = (props) => {
  const { name, identify, phone, createdAt, transactions, ClassicTransaction, LotoTransaction } = props;

  let hasTransaction = 'Không';

  if (transactions.length > 0 && ClassicTransaction.length > 0 && LotoTransaction.length > 0) {
    hasTransaction = 'Tất cả';
  } else if (transactions.length > 0 && ClassicTransaction.length > 0) {
    hasTransaction = 'Vietlott & Kiến Thiết';
  } else if (ClassicTransaction.length > 0 && LotoTransaction.length > 0) {
    hasTransaction = 'Kiến Thiết & Loto';
  } else if (transactions.length > 0 && LotoTransaction.length > 0) {
    hasTransaction = 'Vietlott & Loto';
  } else if (transactions.length > 0) {
    hasTransaction = 'Vietlott';
  } else if (ClassicTransaction.length > 0) {
    hasTransaction = 'Kiến Thiết';
  } else if (LotoTransaction.length > 0) {
    hasTransaction = 'Loto';
  }

  return (
    <tr className='text-center'>
      <td>
        <span>{name || ""}</span><br />
        <span className={`fw-900 text-info`}>{identify || ""}</span>
      </td>
      <td>{phone}</td>
      <td>
        {moment(createdAt || '').format('DD/MM/YYYY HH:mm:ss')}
      </td>
      <td className={`${hasTransaction === 'Không' ? 'text-danger' : hasTransaction === 'Tất cả' ? 'text-success' : 'text-warning'}`}>
        <b>{hasTransaction}</b>
      </td>
    </tr>
  );
};